import {FormattedMessage} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import LoadingSkeleton from '../../cmp/LoadingSkeleton';

export default function Statistic({value, id, cls, loading}) {
    return (<div className={`card ${cls || ''}`}>
        <div className={'card-body'}>
            {
                loading ? <>
                <LoadingSkeleton height={44}/>
                </> : <h2>{value}</h2>
            }
            <small className={'text-muted'}><FormattedMessage id={id}/></small>
        </div>
    </div>);
}

Statistic.propTypes = {
    id: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    value: PropTypes.any.isRequired
};
